import api from "../../api.js";

export const getPatientCreditTransactions = (patientid) =>
  api.get(`/frontshop/debtors/patient/${patientid}/credittransactions`);

export const getCreditAccountCustomers = ({ search = "", page = 1, pageSize = 8 } = {}) =>
  api.get("/frontshop/debtors/creditaccounts", {
    params: { search, page, pageSize },
  });

export const getDebtorsTransactions = ({ search = "", page = 1, pageSize = 5 } = {}) =>
  api.get("/frontshop/debtors/transactions", {
    params: { search, page, pageSize },
  });

export const getDebtorsInvoice = (patientid, month) =>
  api.get(`/frontshop/debtors/patient/${encodeURIComponent(patientid)}/invoice`, {
    params: { month },
  });

export const recordDebtorsPayment = (patientid, { amount, balance, paymentMethod, simple } = {}) =>
  api.post(`/frontshop/debtors/patient/${encodeURIComponent(patientid)}/payment`, {
    amount,
    balance,
    ...(typeof paymentMethod === "string" ? { paymentMethod } : {}),
    ...(typeof simple === "boolean" ? { simple } : {}),
  });

export default getPatientCreditTransactions;
